<template>
  <div id="app">
    <notifications group="default" />
    <navigation v-if="showNavigation()"></navigation>
    <div class="container mt-5">
      <router-view/>
    </div>
  </div>
</template>

<script>
  import Login from './components/authentication/Login';
  import Navigation from './components/Navigation';
  export default {
    name: 'app',
    components: {
      login: Login,
      navigation: Navigation
    },
    methods: {
      showNavigation() {
        return this.$auth.isAuthenticated();
      }
    }

  }
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');

#app {
  font-family: 'Inter', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.my-3 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.ml-1 {
  margin-left: 0.25rem !important;
}

.m-0 {
  margin: 0;
}

a {
  text-decoration: none;
}

.profile-link {
  text-decoration: none;
}
.profile-link:hover {
  text-decoration: underline;
}

.bg-info {
  background-color: #0dcaf0 !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

.bg-grey {
  background-color: #898d91 !important;
}

.bg-green {
  background-color: #05ab5f !important;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.4;
  border-radius: 8px;
  white-space: nowrap;
  background-image: none!important;
  box-shadow: none;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
}
.btn-sm {
  padding: 5px 10px;
  font-size: 12.5px;
}

.bi {
  vertical-align: -0.125em;
}

.btn .bi,
button .bi {
  font-size: 1em;
  line-height: 1;
}

.btn-primary {
  color: #fff;
  background-color: #265a88!important;
  border-color: #265a88!important;
}
.btn-primary:hover,
.btn-primary:focus {
  color: #fff;
  background-color: #1f4a70 !important;
  border-color: #1f4a70 !important;
}

.btn-outline-primary {
  color: #265a88!important;
  border-color: #265a88!important;
  &:hover {
    background-color: #265a88 !important;
    color: white!important;
  }
}

  .font-weight-bold {
    font-weight: 600!important;
  }

  .font-weight-semibold {
    font-weight: 500!important;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2364748b' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e") !important;
    background-repeat: no-repeat !important;
    background-position: right 10px center !important;
    background-size: 14px 10px !important;
    padding-right: 32px !important;
  }


.badge-success {
  color: #03543f;
  background-color: #def7ec;
}

.badge-info {
  color: #265a88;
  background-color: #e1effe;
}

.badge-secondary {
  color: #1f2937;
  background-color: #f3f4f6;
}

.badge-danger {
  color: #9b1c1c;
  background-color: #fde8e8;
}

.text-right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue